import { ActorLayoutVariant } from '../enums/actorLayoutVariant';
import { NaturalPersonFormValues } from '../types/naturalPersonFormValues';
import { ActorForm } from './ActorForm';
import { BranchCode } from "api/risk";
import { useActorRegistrationPanel } from 'features/subscription-process/registration-process/hooks/useActorRegistrationPanel';
import { useMemo } from 'react';

export const UpsertNaturalPerson = () => {

  const {
    formConfig,
    editConfig,
    formikRef,
    handleSubmit,
    handleValidationChange,
    selectedPerson,
  } = useActorRegistrationPanel(BranchCode.Unemployment);

  const formKey = useMemo(() => {
    if (selectedPerson)
      return selectedPerson.id
    return 'new'
  }, [selectedPerson])


  return (
    <div>
      <ActorForm<NaturalPersonFormValues>
        key={formKey}
        layoutVariant={ActorLayoutVariant.UpiActor}
        formConfig={formConfig}
        formikRef={formikRef}
        editConfig={editConfig}
        onValidationChange={handleValidationChange}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
